import { TranslationEntity } from "src/common";

export class InternalUserViewModel {
    id?: number;
    userErpId: string;
    firstName: string;
    lastName: string;
    fullName: string;
    email: string;
    username: string;
    organizationalUnitId?: number;
    companyId?: number;
    userStatusId: number; 
    firstSuperiorId?: number;
    isDeleted: boolean;
    personnelAreaErpId: string;
    personnelAreaName: string;
    employeePositionErpId: string;
    employeePositionName: string;
    updatedBy?: number;
    updatedOn?: Date;
    userStatusName: string;
    companyName: string;
    organizationalUnitName: string;
    userUpdateFullName: string;
    userFirstSuperiorFullName:string;
    translationName: TranslationEntity;
    rolesNameAndId : Array<RolesInUserModel> = [];
}

export class RolesInUserModel
{
    id?:number;
    name: string;

}

export class UserStatusModel {

    id: number;
    name: string;
}